import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { SimpleModal } from 'src/app/components/Modal';
import { StudyGuideMatterModalRow } from './study-guide-matter-modal-row';
import { EmptyState } from '@/components/custom/empty-state';
import { Table, TableBody, TableNoData } from '@/components/ui/table';
import { FilterInput } from '@/components/custom/filter';
import { FiSearch } from 'react-icons/fi';

export function StudyGuideMatterModal(props) {
  const { show, onClose, taxonomies: initialTaxonomies } = props;
  const [taxonomies, setTaxonomies] = useState(initialTaxonomies || []);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedItems, setSelectedItems] = useState({}); // Armazena os itens selecionados

  const { t } = useTranslation();

  useEffect(() => {
    if (show) {
      setSearchTerm('');
      setTaxonomies(initialTaxonomies); // Resetar a lista de taxonomias quando o modal for exibido
      const initialSelected = {};
      initialTaxonomies.forEach(taxonomy => {
        initialSelected[taxonomy.id] = taxonomy['manual-add'] || false;
      });
      setSelectedItems(initialSelected); // Inicializa o estado de seleção com base nas taxonomias
    }
  }, [show, initialTaxonomies]);

  const handleUpdate = updatedTaxonomy => {
    // Atualizar a lista de taxonomias com a nova taxonomia modificada
    const updatedTaxonomies = taxonomies.map(taxonomy => (taxonomy.id === updatedTaxonomy.id ? updatedTaxonomy : taxonomy));
    setTaxonomies(updatedTaxonomies);
  };

  const handleSelectChange = (taxonomyId, isSelected) => {
    setSelectedItems(prevSelected => ({
      ...prevSelected,
      [taxonomyId]: isSelected
    }));
  };

  return (
    <SimpleModal
      show={show}
      onClose={onClose}
      contentClassName="simple-modal__content--lg"
    >
      <h3 className="modal__simple-title">Adicione matérias ao seu guia</h3>

      <div className="mb-5">
        <FilterInput
          label={t('textsCommon.matters')}
          type="search"
          name="search"
          endIcon={FiSearch}
          placeholder={t('textsCommon.research')}
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
        />
      </div>

      <div className="h-[420px] overflow-y-auto">
        <Table className="min-w-[575px]">
          <TableBody>
            {taxonomies
              ?.filter(matter => matter['taxonomy-name'].toLowerCase().includes(searchTerm.toLowerCase()))
              ?.map((matter, index) => {
                return (
                  <StudyGuideMatterModalRow
                    key={index}
                    taxonomy={matter}
                    isSelected={selectedItems[matter.id]} // Passa o estado de seleção
                    onUpdate={handleUpdate}
                    onSelectChange={handleSelectChange} // Função para alterar o estado de seleção
                  />
                );
              })}

            <TableNoData
              notFound={taxonomies && taxonomies.filter(matter => matter['taxonomy-name'].toLowerCase().includes(searchTerm.toLowerCase())).length === 0}
              colSpan={3}
              emptyState={
                <EmptyState
                  type="data"
                  title="Não há matérias disponíveis"
                  text=" "
                />
              }
            />
          </TableBody>
        </Table>
      </div>
    </SimpleModal>
  );
}
